import { guardDialog, showDialog } from '@adornis/dialog/dialog-functions.js';
import { TextareaInput } from '@adornis/formfield/fields/textarea-input.js';
import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { DialogHeader } from '@adornis/components/client/DialogHeader.js';
import { html } from 'lit';
import { updateSalaryFromGpt } from '../api/updateSalaryFromGPT.js';

const SalaryTableInsertDialogContent = stateful((props: { resolve: () => void; reject: () => void }) => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const interpret = async () => {
    if (!content) return;

    setIsLoading(true);
    try {
      // the dialog used to stay open and stuck on the loader whenever the interpretation failed or
      // came back empty, because the loading flag was only cleared on the happy path
      await guardDialog(async () => {
        await updateSalaryFromGpt(content)();
      });
    } finally {
      setIsLoading(false);
    }
    props.resolve();
  };

  return html`
    <div class="dialog-container">
      ${DialogHeader({ title: 'Tariftabelle importieren', close: () => props.reject(), closeLabel: 'Dialog schließen' })}
      ${
        isLoading
          ? html`<div class="flex justify-center p-8"><span class="loading loading-spinner loading-lg"></span></div>`
          : html`
              ${TextareaInput({
                value: content,
                rows: 10,
                placeholder: 'Tariftabelle hier einfügen...',
                onChanged: value => setContent(value ?? ''),
                onPicked: value => setContent(value ?? ''),
              })}
              <div class="flex justify-end gap-2">
                <button class="btn btn-outline" @click=${() => props.reject()}>Abbrechen</button>
                <button class="btn btn-primary" ?disabled=${!content} @click=${interpret}>Einsetzen</button>
              </div>
            `
      }
    </div>
  `;
});

/** Opens the dialog that lets an admin paste a tariff table and have it interpreted into the salary rows. */
export const showSalaryTableInsertDialog = async (): Promise<void> => {
  try {
    await showDialog<void>({
      content: (resolve, reject) => SalaryTableInsertDialogContent({ resolve, reject }),
      modal: true,
      modalBoxClasses: 'max-w-3xl',
      // the textarea is the whole point of this dialog, so let it take focus
      captureFocus: false,
    });
  } catch {
    // dialog was dismissed
  }
};
